import { render, staticRenderFns } from "./personPerformanceConfirmComponent.vue?vue&type=template&id=67a2cc8a&scoped=true&"
import script from "./personPerformanceConfirmComponent.vue?vue&type=script&lang=js&"
export * from "./personPerformanceConfirmComponent.vue?vue&type=script&lang=js&"
import style0 from "./personPerformanceConfirmComponent.vue?vue&type=style&index=0&id=67a2cc8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a2cc8a",
  null
  
)

export default component.exports